import "isomorphic-fetch"

export const geoserverService = {
  WMS: {
    getCapabilities,
    getFeatureInfo,
    getLegendGraphic
  },
  WFS: {
    getFeatures
  }
}

function getFeatureInfo(query_layers, point) {
  let headers = [];
  headers['Content-Type'] = 'text/plain';
  headers['Accept'] = 'application/json'

  const requestOptions = {
    method: 'GET',
    headers: headers
  }

  let layers = query_layers.join(',');
  let bbox = [point[0] - 50 ,point[1] - 50, point[0] + 50, point[1] + 50].join(',');

  const url = process.env.REACT_APP_GeoServer_Url
    + "?service=wms"
    + "&version=1.1.1"
    + "&request=GetFeatureInfo"

    + "&layers=" + layers
    + "&styles="
    + "&srs=EPSG:3765"
    + "&bbox=" + bbox
    + "&width=101"
    + "&height=101"
    + "&query_layers=" + layers
    + "&info_format=application/json"
    + "&feature_count=50"
    + "&x=50"
    + "&y=50"
    ;

    return fetch(url, requestOptions)
    .then( response => {
      return response.text().then( text => {
        const data = text && JSON.parse(text)
        if (!response.ok) {
          const error = (data && data.message) || response.statusText;
          return Promise.reject(error);
        }

        return data;
      })

    })
    .catch( function(error) {

    });
}


function getLegendGraphic(query_layer) {
  let headers = [];
  headers['Content-Type'] = 'text/plain';
  headers['Accept'] = 'application/json';

  const requestOptions = {
    method: 'GET',
    headers: headers
  }

  const url = process.env.REACT_APP_GeoServer_Url
    + "?service=wms"
    + "&version=1.1.1"
    + "&request=GetLegendGraphic"

    + "&layer=" + query_layer
    + "&width=20"
    + "&height=20"
    + "&format=application/json"
    // + "&format=image/png"
    ;

    // console.log(url);

    // return fetch(url, requestOptions)
    // .then(response=>{return response.blob()})
    // .catch( function(error) {
    // });

    return fetch(url, requestOptions)
      .then( response => {
      return response.text().then( text => {
        const data = text
        if (!response.ok) {
          const error = (data && data.message) || response.statusText;
          return Promise.reject(error);
        }

        return data;
      })

    })
    .catch( function(error) {

    });

}

function getCapabilities() {
  let headers = [];
  headers['Content-Type'] = 'text/plain';
  headers['Accept'] = 'text/xml';

  const requestOptions = {
    method: 'GET',
    headers: headers
  }

  const url = process.env.REACT_APP_GeoServer_Url
    + "?service=wms"
    + "&version=1.3.0"
    + "&request=GetCapabilities"
    ;

  return fetch(url, requestOptions)
    .then( response => {
      return response.text().then( text => {
        const data = text
        if (!response.ok) {
          const error = (data && data.message) || response.statusText;
          return Promise.reject(error);
        }

        return data;
      })

    })
    .catch( function(error) {

    });
}

function getFeatures(query_layer) {
  let headers = [];
  headers['Content-Type'] = 'text/plain';
  headers['Accept'] = 'application/json';

  const requestOptions = {
    method: 'GET',
    headers: headers
  }

  const url = process.env.REACT_APP_GeoServer_WFS_Url
    + "?service=wfs"
    + "&version=1.0.0"
    + "&request=GetFeature"
    + "&typeName=" + query_layer
    + "&maxFeatures=999"
    + "&outputFormat=application/json"
    ;

    return fetch(url, requestOptions)
    .then( response => {
      return response.text().then( text => {
        const data = text
        if (!response.ok) {
          const error = (data && data.message) || response.statusText;
          return Promise.reject(error);
        }

        return data;
      })

    })
    .catch( function(error) {

    });

}